import styled from "styled-components";
import { ToastContainer, ToastContainerProps } from "react-toastify";
import { defaultToastContainerProps, toastContainerStyleSheet } from "@beamcloud/design-system";

const StyledToastContainer = styled(ToastContainer).attrs(defaultToastContainerProps as ToastContainerProps)`
  ${toastContainerStyleSheet}
`;

export default StyledToastContainer;
